import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import { Fare } from '@/src/types/itinerary'
import { getFareBrandDetails } from '@/src/utils/itinerary/fareFamily'
import useGetItineraryId from '../../useGetItineraryId'

const useSmbMandatoryCheck = () => {
    const itineraryId = useGetItineraryId()
    const { fareFamilyFares, meta } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => ({
                fareFamilyFares: data?.fareFamilyFares || [],
                meta: data?.meta
            })
        }
    )
    const { meal: mealMetaData = {}, seat: seatMetaData = {} } = meta?.smbEligibility || {}
    const selectedFareFamily = fareFamilyFares.find((fare: Fare) => fare.selected)
    const { ctBrandName } = selectedFareFamily ? getFareBrandDetails(selectedFareFamily) : { ctBrandName: 'REGULAR' }
    const isSeatMandatory = !!seatMetaData?.[ctBrandName]?.isMandatory
    const isMealMandatory = !!mealMetaData?.[ctBrandName]?.isMandatory

    return {
        isSeatMandatory,
        isMealMandatory
    }
}

export default useSmbMandatoryCheck
